export const generateAvatar = (name) => {
  const names = name
    ?.split(" ")
    ?.filter((word) => word && !["Dr.", "Dr"]?.includes(word));

  if (names?.length > 1) {
    const firstLetter = names?.[0]?.charAt(0);
    const lastLetter = names[names?.length - 1].charAt(0);
    return (firstLetter + lastLetter)?.toUpperCase();
  }

  return names?.[0]?.slice(0, 2)?.toUpperCase() || "";
};
